import { SoldierDTO } from '../types';

export interface SoldierGroup {
  type: string;
  members: SoldierDTO[];
}

const typeOrder: Record<string, number> = {
  StandardSoldier: 0,
  SpecialistSoldier: 1,
  Creature: 2,
  Temporary: 3,
};

const getSoldierTypeKey = (soldier?: SoldierDTO | null): string => {
  if (!soldier) return 'Unknown';

  if (soldier.isTemporary) {
    return 'Temporary';
  }

  if (soldier.type === 'Creature') {
    return 'Creature';
  }

  return soldier.type?.trim() || 'Unknown';
}

const getPlayModeSoldierTypeKey = (soldier?: SoldierDTO | null): string => {
  if (!soldier) return 'Unknown';

  if (soldier.isTemporary) {
    return 'Temporary';
  }

  return 'Soldier';
}

export const groupSoldiersByType = (soldiers: SoldierDTO[], playMode: boolean): SoldierGroup[] => {
  const groups = soldiers.reduce<Record<string, SoldierDTO[]>>((accumulator, soldier) => {
    const typeKey = playMode ? getPlayModeSoldierTypeKey(soldier) : getSoldierTypeKey(soldier);
    if (!accumulator[typeKey]) {
      accumulator[typeKey] = [];
    }
    accumulator[typeKey].push(soldier);
    return accumulator;
  }, {});

  return Object.entries(groups)
    .sort(([leftType], [rightType]) => {
      const leftOrder = typeOrder[leftType] ?? Number.MAX_SAFE_INTEGER;
      const rightOrder = typeOrder[rightType] ?? Number.MAX_SAFE_INTEGER;

      if (leftOrder !== rightOrder) {
        return leftOrder - rightOrder;
      }

      return leftType.localeCompare(rightType);
    })
    .map(([type, members]) => ({
      type,
      members: [...members].sort((left, right) => left.name.localeCompare(right.name)),
    }));
};
